module.exports = __webpack_public_path__ + "img/download.5f67c83a.svg";